import type {PackVisualStage} from '@core/utils/analytics'

/**
 * The stages a narcis pack page's workbench can show. The page's state decides it — nothing the
 * visitor does on the stage changes it.
 *
 *   ad             — anonymous visitor: the curated nine, then the model path
 *   no_model       — signed in, no model yet: the same nine, the same model path
 *   waiting_model  — a model is training: the nine under the training bar
 *   model_ready    — the owner, run not started: the nine and the Generate action
 *   buying         — the owner, run in progress: slots fill in as they land
 *   done           — the owner, run delivered: the nine renders
 */
export type PackStage = Extract<
    PackVisualStage,
    'ad' | 'no_model' | 'waiting_model' | 'model_ready' | 'buying' | 'done'
>

/** The stages whose card shows the pack's curated nine rather than the owner's run — where the coda
 *  and the look door can sit (plan 2026_09_25_narcis_pack_coda.md). */
export const SHOWCASE_STAGES: readonly PackStage[] = ['ad', 'model_ready', 'no_model', 'waiting_model']

type HeroState = 'A' | 'B' | 'C' | 'D'
type OwnerSubState = 'D' | 'D-gen' | 'D-del' | null

export function packStageFor(heroState: HeroState, ownerSubState: OwnerSubState): PackStage {
    if (heroState === 'D') {
        return ownerSubState === 'D-gen' ? 'buying' : ownerSubState === 'D-del' ? 'done' : 'model_ready'
    }
    if (heroState === 'C') return 'waiting_model'
    return heroState === 'B' ? 'no_model' : 'ad'
}
